import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import CommonHeader from '../../../util_components/common_header';
import CustomLoading from '../../../util_components/custom_loading';
import * as actions from '../../../../redux/action_creators';
import PaymentAttributes from '../teacher_profile/payment_attributes';
import BaseRateLine from '../../teacher_payments/base_rate/base_rate_line';
import ChangeHistory from './change_history';
import './teacher_payment_details.css';
import {
  is_onboarding_only,
  needs_profile_fetch,
  page_state,
  profile_for,
  teacher_display_name,
  teacher_id_from_search,
  teacher_profile_url
} from './logic';

// payment attributes + base rate, moved off the teacher profile onto their own page.
const TeacherPaymentDetails = () => {
  const { search } = useLocation();
  const uuid = teacher_id_from_search(search);
  const dispatch = useDispatch();
  const details = useSelector((s) => s.teachers.teacher_profile_details);
  const status = useSelector((s) => s.teachers.teacher_profile_status);
  const onboarding_only = is_onboarding_only(useSelector((s) => s.home?.access_type));
  const fetched_for = useRef('');
  // Bumped when a card saves, so the change history reloads.
  const [history_version, setHistoryVersion] = useState(0);
  const teacher = profile_for(details, uuid);

  useEffect(() => {
    if (needs_profile_fetch({ details, status, uuid, fetched_for: fetched_for.current })) {
      fetched_for.current = uuid;
      dispatch(actions.get_teacher_profile_details(uuid));
    }
  }, [details, status, uuid, dispatch]);

  const state = page_state({ details, status, uuid, fetched_for: fetched_for.current });
  if (state === 'invalid') return <div className="custom-page-center">Please enter valid url</div>;
  if (state === 'error')
    return <div className="custom-page-center">Could not load this teacher.</div>;
  if (state === 'loading') return <CustomLoading />;

  const name = teacher_display_name(teacher);
  const on_notify = (type, message) =>
    dispatch(actions.set_notification_variable(true, type, message));
  const on_saved = () => setHistoryVersion((v) => v + 1);

  return (
    <CommonHeader
      class_name="tp-fullwidth"
      title="Payment details"
      subtitle={name}
      meta_title={`${name || 'Teacher'} - Payment details`}
    >
      {/* .tp-page: the module's type and spacing scale; the shell pads the page. */}
      <div className="tp-page tp-tpd">
        <Link to={teacher_profile_url(uuid)} className="tp-link tp-tpd-back">
          &larr; Back to teacher profile
        </Link>
        {/* The shell heading is hidden on .tp-page routes, so the page names its teacher here. */}
        <h1 className="tp-tpd-title">{name ? `Payment details · ${name}` : 'Payment details'}</h1>
        <PaymentAttributes teacher_uuid={uuid} on_saved={on_saved} />
        <BaseRateLine
          teacher_uuid={uuid}
          teacher_name={name}
          profile_base_rate={teacher.base_rate}
          on_notify={on_notify}
          on_changed={on_saved}
        />
        <ChangeHistory
          teacher_uuid={uuid}
          version={history_version}
          onboarding_only={onboarding_only}
        />
      </div>
    </CommonHeader>
  );
};

export default TeacherPaymentDetails;
